import { Badge } from "reactstrap"

import { formatCurrency } from "utils/formatCurrency"
import { formatReadableDate } from "utils/formatDate"

const STATUS_COLORS = {
  paid: "success",
  partially_paid: "warning",
  cancelled: "secondary",
  rejected: "danger",
  pending: "info",
}

const BillInfoCell = ({ bill }) => {
  if (!bill) return <span className="text-muted">-</span>

  const employee = (bill.employee && bill.employee.name) || (bill.snapshot_data && bill.snapshot_data.employee && bill.snapshot_data.employee.name) || "-"
  const purpose =
    (bill.payment_for && bill.payment_for.name) ||
    (bill.paymentFor && bill.paymentFor.name) ||
    (bill.expense_type && bill.expense_type.name) ||
    (bill.expenseType && bill.expenseType.name) ||
    (bill.snapshot_data && bill.snapshot_data.payment_for && bill.snapshot_data.payment_for.name) ||
    (bill.snapshot_data && bill.snapshot_data.expense_type && bill.snapshot_data.expense_type.name) ||
    "-"
  const amount = formatCurrency(bill.amount || 0, "BDT")
  const paid = formatCurrency(bill.paid_amount || 0, "BDT")
  const adjusted = formatCurrency(bill.adjusted_amount || 0, "BDT")
  const statusColor = STATUS_COLORS[bill.status] || "info"
  const items = Array.isArray(bill.items) ? bill.items : []
  const itemVehicleLabel = item => {
    const vehicle = item.vehicle || {}
    return [vehicle.stock_id, vehicle.full_chassis].filter(Boolean).join(" / ")
  }

  return (
    <div style={{ minWidth: 220, maxWidth: 320 }}>
      <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
        <span className={`badge bg-${statusColor}`}>
          {bill.status ? String(bill.status).split("_").join(" ") : "pending"}
        </span>
        <small className="text-muted">{formatReadableDate(bill.created_at)}</small>
      </div>

      <div className="d-flex align-items-center justify-content-between gap-1 mb-1">
        <span className="fw-semibold text-truncate" title={employee}>
          {employee}
        </span>
        <small className="text-muted flex-shrink-0">{bill.bill_no || `#${bill.id}`}</small>
      </div>

      {items.length > 1 ? (
        <div className="text-muted small">
          {items.slice(0, 2).map(item => (
            <div key={item.id || `${item.payment_for_id}-${item.amount}`} className="d-flex justify-content-between gap-2">
              <span className="text-truncate" title={itemVehicleLabel(item) || undefined}>
                <i className="bx bx-receipt me-1" />
                {(item.payment_for && item.payment_for.name) || (item.expense_type && item.expense_type.name) || "-"}
                {itemVehicleLabel(item) && <span className="text-muted"> · {itemVehicleLabel(item)}</span>}
              </span>
              <span className="fw-semibold">{formatCurrency(item.amount || 0, "BDT")}</span>
            </div>
          ))}
          {items.length > 2 && <div className="text-muted">+{items.length - 2} more item(s)</div>}
          <div className="fw-semibold mt-1">Total: {amount}</div>
        </div>
      ) : (
        <div className="d-flex flex-wrap gap-3 text-muted small">
          <span>
            <i className="bx bx-receipt me-1" />
            {purpose}
          </span>
          <span>
            <i className="bx bx-money me-1" />
            {amount}
          </span>
        </div>
      )}

      <div className="text-muted small mt-1">
        Paid: <span className="fw-semibold">{paid}</span>
        {" / "}Adjusted: <span className="fw-semibold">{adjusted}</span>
      </div>

      {bill.notes && (
        <div className="text-muted small mt-1 text-truncate" title={bill.notes}>
          <i className="bx bx-comment me-1" />
          {bill.notes}
        </div>
      )}
    </div>
  )
}

export default BillInfoCell
